<template>
	<Col class="height-100 width-100 page-container">
		<Col class="pa-4 overflow-y-auto height-100 width-100">
			<Row class="flex-align-center flex-justify-space-between">
				<Row class="task-log-title">Task log</Row>
				<AnemicButton @click="closeDrawer" rounded class="pa-0 close-button">x</AnemicButton>
			</Row>
			<v-slide-x-transition mode="out-in">
				<router-view v-on="$listeners" />
			</v-slide-x-transition>
		</Col>
	</Col>
</template>

<script>
import { BUILDER_DEBUG_MODE_ROUTE_NAME } from '@/router/router.const.js';
export default {
	name: BUILDER_DEBUG_MODE_ROUTE_NAME,
	methods: {
		closeDrawer() {
			this.$emit('close');
		},
	},
	created() {
		this.$emit('closeRightSideBar');
	},
};
</script>
<style scoped lang="scss">
.task-log-title {
	font-size: 20px;
	font-weight: medium;
	color: var(--primary-font-color);
}
.close-button {
	width: 22px !important;
	height: 22px !important;
	font-size: 12px !important;
	color: #5a677c !important;
	font-weight: normal !important;
	background: #f5f7fa !important;
	border: 1px solid #e7eaf3 !important;
}
.page-container {
	border-right: 1px solid #dce0e9;
}
</style>
